import { MediaQueries } from 'custom_hooks/useWindowSize';
import { ChartDataPlotSvgContainer } from 'pages/Desk/issues/chart_data/styled';
import styled, { css } from 'styled-components';
import { backgroundColor, borderColor, secondaryBackgroundColor } from 'styles/theme';
import { KCFColor } from 'styles/themes/KCFColor';

export const SingleItemWrapper = styled.div<{ $noBorder?: boolean }>`
    display: flex;
    gap: 1.5rem;
    padding: 1.5rem;
    align-items: center;

    ${({ $noBorder }) =>
        $noBorder
            ? ''
            : css`
                  border-bottom: solid 2px ${borderColor};
              `}

    &:last-child {
        border-bottom: none;
    }
`;

export const MultiItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: solid 2px ${borderColor};
`;

export const ContentWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr auto;
    column-gap: 1rem;
    align-items: start;
    font-size: 1.4rem;

    @media ${MediaQueries.smallAndDown} {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const SecondaryContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: -1.25rem 0rem 2rem 7rem;
    gap: 1rem;
    font-size: 1.4rem;
`;

export const ActivityTextWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
`;

export const InlineActivityTextWrapper = styled.div`
    display: inline;
`;

export const Actions = styled.div`
    display: flex;
    gap: 1rem;
`;

export const BottomBarWrapper = styled.div`
    display: flex;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    background-color: ${secondaryBackgroundColor};
`;

export const Attachments = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
`;

export const Divider = styled.div`
    margin: 0.25rem 0rem;
    border-right: 2px solid ${KCFColor.mediumGrey4};
    border-radius: 0.5rem;
`;

export const QuoteContent = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 2rem;
    font-size: 1.4rem;
`;

export const FormattedText = styled.div`
    white-space: pre-line;
    flex-wrap: wrap;
    overflow-wrap: anywhere;
    font-size: 1.4rem;
`;

export const LozengeWrapper = styled.span`
    margin: 0rem 0.3rem;
`;

export const ChartPanel = styled.div`
    width: 100%;
    background: ${backgroundColor};
    border-radius: 0.8rem;
    overflow: hidden;

    & + & {
        margin-top: 1.5rem;
    }
`;

export const ChartDataSvgContainer = styled.div`
    font-size: 1.4rem;
`;

export const ChartImage = styled.div`
    cursor: pointer;
    border-top: solid 1px ${borderColor};

    ${ChartDataPlotSvgContainer} {
        margin: 0 1rem 1rem 1rem;
        border: none;

        img {
            border: none;
        }
    }
`;

export const ChartDataToolbar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 1rem 2rem;
`;

export const ChartDataOptions = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
`;

export const ChartDataLegendContainer = styled.div`
    padding: 2rem;
`;

export const ChartDataLegend = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    column-gap: 1rem;
    row-gap: 0.8rem;
    align-items: center;

    @media ${MediaQueries.largeAndUp} {
        grid-template-columns: repeat(2, 1fr);
    }

    @media ${MediaQueries.xlargeAndUp} {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const ChartDataLegendItem = styled.div`
    display: flex;
    gap: 0.8rem;
    align-items: center;
`;

export const ChartDataLegendItemColor = styled.div<{ $color: string }>`
    display: inline-block;
    flex-shrink: 0;
    height: 1.4rem;
    width: 1.4rem;
    border-radius: 2px;
    background-color: ${({ $color }) => $color};
`;
